import { Injectable, Inject } from '@angular/core';
import { RequestCommon, Sgkb983aRequest, Sgkb983aReqAceptInfoDto, Sgkb983aResponse, SGKB983AService } from 'sg-api';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb941dSgkb983aService {

  constructor(private sGkb983A: SGKB983AService, private apiCommonService: ApiCommonService, private timeApiService: TimeApiService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }
  /**
   * 受付エラー更新
   *
   * @param {Sgkb983aRequest} sgkb983aRequest
   * @return {*}  {Observable<Sgkb983aResponse>}
   * @memberof UsedSgkb941dSgkb983aService
   */
  registReception(sgkb983aRequest: any): Observable<Sgkb983aResponse> {

    let request: Sgkb983aRequest = {
      aceptInfo: this.createReceptionInfo(sgkb983aRequest.aceptInfo),

      requestCommon: this.createCommonRequestCommon(sgkb983aRequest.requestCommon.requestCustomize)
    }

    if (sgkb983aRequest.aceptInfo.aceptSts != null) {
      request.aceptInfo.aceptSts = sgkb983aRequest.aceptInfo.aceptSts;
    }

    return this.sendPostRequest(this.apiCommonService.setRequestCommon(<Sgkb983aRequest>request));
  }

  /**
   * 受付情報リクエスト作成
   *
   * @private
   * @param {Sgkb983aReqAceptInfoDto} aceptInfo
   * @return {*}  {Sgkb983aReqAceptInfoDto}
   * @memberof UsedSgkb941dSgkb983aService
   */
  private createReceptionInfo(aceptInfo: Sgkb983aReqAceptInfoDto): Sgkb983aReqAceptInfoDto {
    let sgkb983aReqAceptInfoDto: Sgkb983aReqAceptInfoDto = {
      aceptNo: aceptInfo?.aceptNo,
      aceptRrkno: aceptInfo?.aceptRrkno,
      updateSrno: aceptInfo?.updateSrno,
    };

    return sgkb983aReqAceptInfoDto;
  }

  /**
   * SGKB983Aリクエスト送信
   *
   * @private
   * @param {Sgkb983aRequest} request
   * @return {*}  {Observable<Sgkb983aResponse>}
   * @memberof UsedSgkb941dSgkb983aService
   */
  private sendPostRequest(request: Sgkb983aRequest): Observable<Sgkb983aResponse> {

    // 年月日項目のフォーマット
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);

    return this.sGkb983A.SGKB983APost(request, 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB, SgkbConstains.MESSAGE.APINAME_SGKB983A);
          return throwError(err.message);
        })
      );
  }

  /**
   * requestCustomizeを入れる
   */
  private createCommonRequestCommon(requestCustomize: object): RequestCommon {
    return <RequestCommon>{
      requestCustomize: requestCustomize,
    };
  }
}

